import { render, staticRenderFns } from "./SingleRepairTemplate.vue?vue&type=template&id=38f8a8ab&scoped=true"
import script from "./SingleRepairTemplate.vue?vue&type=script&lang=js"
export * from "./SingleRepairTemplate.vue?vue&type=script&lang=js"
import style0 from "./SingleRepairTemplate.vue?vue&type=style&index=0&id=38f8a8ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f8a8ab",
  null
  
)

export default component.exports